import '../../css/pages/about/about-team.scss';